module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/poster-ai-96da7dc489e17c9cf9ae2627e2499d30.png";